import React from "react";

const ChevronUpSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.357"
      height="8.076"
      viewBox="0 0 14.357 8.076"
      className="w-full"
    >
      <path
        id="drop_down"
        data-name="drop down"
        d="M.216.721A.728.728,0,0,1,1.178.648l.083.073L7.178,6.757,13.1.721a.728.728,0,0,1,.962-.073l.083.073a.765.765,0,0,1,.072.981l-.072.084L7.7,8.355a.728.728,0,0,1-.962.073l-.083-.073L.216,1.786A.764.764,0,0,1,.216.721Z"
        transform="translate(14.357 8.576) rotate(180)"
        fill="#fff"
      />
    </svg>
  );
};

export default ChevronUpSvg;
